import PhotoGridViewerFooter from './PhotoGridViewerFooter';

export default PhotoGridViewerFooter;
